<template>
	<sky-suffix v-bind="tableData" :content="tipContent" :showToolTip="isShowTip">
		<div class="default-text" :style="{ marginRight: tableData.right + 'px' }">
			<span
				v-if="!tableData.showHover"
				class="default-text"
				@click.stop="stopClick"
				:class="tableData.getClass ? tableData.getClass(scope.row) : ''"
				>{{ getText(tableData.bind) | dataListFormat(tableData.formartAmout, scope.row) }}</span
			>

			<el-tooltip v-if="tableData.showHover" class="item" effect="dark" placement="top-start">
				<span
					:class="
						typeof tableData.className === 'function' && tableData.className(scope.row)
							? tableData.className(scope.row)
							: 'defaut-text'
					"
					>{{ getText(tableData.bind) | dataListFormat(tableData.formartAmout, scope.row) }}</span
				>
				<div slot="content">
					<span class="default-text" v-if="tableData.hoverContent">{{
						scope.row[tableData.hoverContent] | dataListFormat(tableData.formartAmout, scope.row)
					}}</span>
					<span
						v-else
						class="default-text"
						:class="tableData.getClass ? tableData.getClass(scope.row) : ''"
						>{{ getText(tableData.bind) | dataListFormat(tableData.formartAmout, scope.row) }}</span
					>
				</div>
			</el-tooltip>
		</div>
	</sky-suffix>
</template>

<script>
import filters from '@/mixins/filters';
import SkySuffix from '@/components/iglobalwin/formComponents/SkySuffix.vue';

export default {
	name: 'default-text',
	props: ['tableData', 'scope'],
	components: { SkySuffix },
	mixins: [filters],
	data() {
		return {};
	},
	computed: {
		isShowTip(self) {
			if (typeof self.tableData.isShowTip === 'function') {
				return self.tableData.isShowTip(self.scope.row);
			}
			return self.tableData.isShowTip || false;
		},
		tipContent(self) {
			if (typeof self.tableData.tipContent === 'function') {
				return self.tableData.tipContent(self.scope.row);
			}
			return self.tableData.tipContent || '';
		},
	},
	methods: {
		getText(val) {
			if (typeof val === 'function') {
				return val(this.scope.row, this.scope.$index);
			} else {
				return this.scope.row[val];
			}
		},
		stopClick() {
			this.$emit('stopClick');
		},
	},
};
</script>
<style lang="scss" scoped>
.deathText {
	color: #909399;
}
.normalText {
	color: #67c23a;
}
.danger {
	color: #f56c6c;
}
.warning {
	color: #e6a23c;
}
.default-text {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	cursor: pointer;
}
</style>
